<template>
  <div class="sm-reports-period">
    <template v-if="showControls">
      <tabs-elem
        v-if="viewPort == 'large'"
        :tabs="tabs"
        :param="'period'"
        :preselect="preselect"
        @switch="switchTab($event.tab)"
      />
      <dropdown-wrap
        v-else
        v-model="period"
        :val="periods[0]"
        :options="periods"
        @input="selectPeriod"
      />
    </template>
    <div
      v-if="showDatepickers" 
      class="sm-reports-period__datepicker"
    >
      <datepicker-wrap
        :val="from"
        :outerVal="from"
        :notAfter="to ? new Date(to) : null"
        :placeholder="'From'"
        :type="datePickersType"
        @input="customDateSelect($event, 'from')"
      />
      <datepicker-wrap
        :val="to"
        :outerVal="to"
        :notBefore="from && toSameDate? new Date(from).setMonth(new Date(from).getMonth() -1 ) : (from ? new Date(from) : null)"
        :placeholder="'To'"
        :type="datePickersType"
        :isToLastDay="isToLastDay"
        @input="customDateSelect($event, 'to')"
      />
    </div>
  </div>
</template>

<script>
import Tabs from '@/components/Tabs';
import DatepickerWrap from '@/components/DatepickerWrap';
import DropdownWrap from '@/components/DropdownWrap';
import ViewPort from '@/mixins/ViewPort';

export default {
  name: 'period-select',
  components: {
    'tabs-elem': Tabs,
    'datepicker-wrap': DatepickerWrap,
    'dropdown-wrap': DropdownWrap
  },
  props: {
    preselect: {
      type: Boolean,
      default: true
    },
    datePickersType: {
      type: String,
      default: 'date',
    },
    toSameDate: {
      type: Boolean,
      default: false,
    },
    isToLastDay: {
      type: Boolean,
      default: false
    },
    startFrom: {},
    startTo: {},
    showControls: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      from: null,
      to: null,
      showDatepickers: true,
      period: null,
      periods: [
        {
          name: 'All time',
          value: 'all'
        },
        {
          name: 'Year',
          value: 'year'
        },
        {
          name: 'Half-year',
          value: 'half-year'
        },
        {
          name: 'Quarter',
          value: 'quarter'
        },
        // {
        //   name: 'Custom',
        //   value: 'custom'
        // }
      ],
      tabs: [
        {
          tab: 'all',
          text: 'All time'
        },
        {
          tab: 'year',
          text: 'Year'
        },
        {
          tab: 'half-year',
          text: 'Half-year'
        },
        {
          tab: 'quarter',
          text: 'Quarter'
        }
      ],
      allowedBreakpoints: [
        'small',
        'large'
      ],
    }
  },
  created() {
    if (this.startFrom)
      this.from = this.startFrom;

    if (this.startTo)
      this.to = this.startTo;
  },
  mixins: [ViewPort],
  methods: {
    getLastDayOfMonth(d) {
      let date = d;
      if (!d) date = new Date();
      if(date) 
        return this.$moment(new Date(date).setMonth(new Date(date).getMonth() + 1, 0)).format('YYYY-MM-DD');
    },
    switchTab(tab) {
      let today = new Date();
      let targetDate = new Date();
      let type = 'period'

      switch(tab) {
        case 'quarter': 
          targetDate.setMonth(new Date().getMonth() - 3);
          break;
        case 'half-year': 
          targetDate.setMonth(new Date().getMonth() - 6);
          break;
        case 'year':
          targetDate.setFullYear(new Date().getFullYear() - 1);
          break;
        case 'all':
        default:
          targetDate = null;
          today = null;
          type="all-time"
          break;
      }

      this.from = targetDate ? this.$moment(targetDate).format('YYYY-MM-DD') : null;//targetDate;
      this.to = today ? this.$moment(today).format('YYYY-MM-DD') : null;//today;

      this.$emit('set-period', targetDate, today, type);

      // re-render datepickers
      this.showDatepickers = false;
      this.$nextTick(() => {
        this.showDatepickers = true;
      });
    },
    customDateSelect(val, type) {
      this[type] = val;//new Date(val);

      if (!val || val.toLowerCase().includes('invalid'))
        return;

      if (this.from && this.to)
        this.$emit('set-period', this.from, this.to, 'period');
    },
    selectPeriod() {
      if (this.period.value != 'custom') {
        this.switchTab(this.period.value);
      } else {
        console.log('custom');
      }
    }
  },
  watch: {
    startFrom(val) {
      this.from = val;
    },  
    startTo(val) {
      this.to = val;
    },
  },
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/components/reports/_period-select.scss';
</style>